import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { ArrowShortRightSvg } from './ArrowShortRight';

export const ArrowShortRightIcon = createIcon('arrowShortRight', ArrowShortRightSvg);
/**
 * @deprecated используйте ArrowShortRightIcon
 */
export const withArrowShortRightIcon = withIcon('arrowShortRight', ArrowShortRightSvg);
